module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "serviceformContainer"
  }, [_c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "append-icon": "search",
      "label": "Search",
      "solo": "",
      "single-line": ""
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  }), _c('br')], 1), _vm._v(" "), _c('v-data-table', {
    ref: "sortableTable",
    staticClass: "elevation-1",
    attrs: {
      "loading": "true",
      "headers": _vm.headers,
      "items": _vm.processList,
      "search": _vm.search,
      "hide-actions": "",
      "disable-initial-sort": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', {
          staticClass: "sortableRow",
          attrs: {
            "id": "rows"
          }
        }, [_c('td', {
          attrs: {
            "width": "30%"
          }
        }, [_vm._v(_vm._s(props.item.name))]), _vm._v(" "), _c('td', {
          attrs: {
            "width": "18%"
          }
        }, [_vm._v(_vm._s(props.item.departmentName))]), _vm._v(" "), _c('td', {
          attrs: {
            "width": "14%"
          }
        }, [_vm._v(_vm._s(_vm.fncGetLocalizedDateFromUTC(props.item.created_on)))]), _vm._v(" "), _c('td', {
          attrs: {
            "width": "10%"
          }
        }, [_vm._v(_vm._s(props.item.id))]), _vm._v(" "), _c('td', {
          attrs: {
            "width": "7%"
          }
        }, [(_vm.fncCanDo()) ? _c('a', {
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.fncCreateLink(props.item)
            }
          }
        }, [_c('i', {
          staticClass: "material-icons"
        }, [_vm._v("link")])]) : _vm._e()]), _vm._v(" "), _c('td', {
          attrs: {
            "width": "7%"
          }
        }, [(_vm.fncCanDo()) ? _c('a', {
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.fncShowEdit(props.item)
            }
          }
        }, [_c('i', {
          staticClass: "material-icons"
        }, [_vm._v("edit")])]) : _vm._e()]), _vm._v(" "), _c('td', {
          attrs: {
            "width": "7%"
          }
        }, [(_vm.fncCanDo()) ? _c('a', {
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.fncProcessDelete(props.item)
            }
          }
        }, [_c('i', {
          staticClass: "material-icons"
        }, [_vm._v("delete")])]) : _vm._e()]), _vm._v(" "), _c('td', {
          attrs: {
            "width": "7%"
          }
        }, [(_vm.fncCanDo()) ? _c('a', {
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.fncProcessDuplicate(props.item)
            }
          }
        }, [_c('i', {
          staticClass: "material-icons"
        }, [_c('span', {
          staticClass: "material-icons-outlined"
        }, [_vm._v("table_view")])])]) : _vm._e()])])]
      }
    }])
  })], 1)
},staticRenderFns: []}